import { useTranslation } from 'react-i18next';
import type { ReportableType } from '../types/report';

type ReportableWithOptions = Exclude<ReportableType, 'issue'>;

export function useReportOptions(contentType: ReportableWithOptions) {
  const { t } = useTranslation('reports');

  const keys: Record<ReportableWithOptions, string[]> = {
    job: ['fraudulent_offer', 'inappropriate_content', 'false_information', 'other'],
    profile: ['fake_identity', 'inappropriate_or_offensive', 'spam_or_scam', 'other'],
    review: ['abusive_review', 'spam', 'conflict_of_interest', 'other'],
    quote: ['fraudulent_quote', 'inappropriate_content', 'harassment', 'other'],
    quote_request: ['fraudulent_request', 'inappropriate_content', 'harassment', 'other'],
  };

  return keys[contentType].map(key => ({
    key,
    label: t(`${contentType}.reasons.${key}`),
  }));
}
